<template>
  <div class="setting-main-container" v-if="getBusinessPermission || userType=='super_admin'">
    <div class="card setting-card">
      <table-component
        ref="stakeholderTable"
        :show-filter="false"
        :data="stakeholders"
        table-class="table tax-table"
        class="mb-3"
      >
        <table-column
          :sortable="true"
          :label="$t('profile.stakeholder.name')"
          show="name"
        />
          <table-column
          :sortable="true"
          :label="$t('profile.stakeholder.role')"
          show="role"
        />
        <table-column
          :sortable="true"
          :label="$t('profile.stakeholder.cnic')"
          show="cnic"
        />
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown"
        >
          <template slot-scope="row">
            <span>{{ $t('settings.tax_types.action') }}</span>
            <v-dropdown><a slot="activator" href="#"><dot-icon /></a>
              <v-dropdown-item>
                <div class="dropdown-item" @click="viewStakeHolder(row)">
                  <font-awesome-icon :icon="['fas', 'eye']" class="dropdown-item-icon" />
                    {{ $t('general.view') }}
                </div>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
const { required, maxLength, alpha,minLength,email } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
      userType:null,
    }
  },
  computed: {
    ...mapGetters('stakeholder', [
      'stakeholders'
    ]),
    ...mapGetters('business', [
      'business' ,
      'getBusinessPermission',
    ]),
  },
  watch: {
  },
  validations: {
     formData: {}
  },
  created() {
    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    this.checkBusinessPermission();
    this.getStakeholers();
  },
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('stakeholder', [
      'fetchStakeholdersByUser',
    ]),
    getStakeholers(){
      let data ={
        user_id:this.$route.params.id
      }
      let res =  this.fetchStakeholdersByUser(data)
    },
    viewStakeHolder(data){
       this.openModal({
        'title': 'View Owner/Partner/Director',
        'componentName': 'ViewStakeholderModal',
        'id': data.id,
        'data': data
      })
      this.$refs.stakeholderTable.refresh()
    },
    ...mapActions('business', [
      'BusinessPermission',
      'falseBusinessPermission'
    ]),
    checkBusinessPermission(){
        this.BusinessPermission(this.$route.params.id)
    }
  }
}
</script>
